import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container, Button } from "../globalStyle";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { Link } from "react-scroll";
import { IconContext } from "react-icons/lib";
import { FaTimes, FaBars } from "react-icons/fa";
import Typewriter from "typewriter-effect";
import { socialMediaLink } from "../pages/HomePage/Data";

const Nav = styled.nav`
  background: #101522;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2 rem;
  position: sticky;
  top: 0;
  z-index: 999;
`;

const NavbarContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  height: 80px;
  ${Container}
`;

const NavLogo = styled(Link)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
`;

const NavIcon = styled(HiOutlineDesktopComputer)`
  margin-right: 0.5rem;
  color: white;
`;

const NavHeading = styled.div`
  font-size: 1.3rem;
`;

const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 960px) {
    display: block;
    top: 0;
    right: 0;
    position: absolute;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 80px;
    left: ${({ click }) => (click ? 0 : "-100%")};
    opcaity: 1;
    transition: all 0.5s ease;
    background: #101522;
  }
`;

const NavItem = styled.li`
  height: 80px;
  border-bottom: 2px solid transparent;
  & :hover {
    border-bottom: 2px solid #4b59f7;
  }
  @media screen and( max-width: 960px) {
    width: 100%;
    &:hover {
      border: none;
    }
  }
`;

const NavLink = styled(Link)`
  color: white;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  @media screen and( max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
    &:hover {
      color: #4b59f7;
      transition: all 0.3s ease;
    }
  }
`;

const NavItemBtn = styled.li`
  @media screen and (max-width: 960px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
  }
`;

const NavBtnLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding: 8px 16px;
  height: 100%;
  width: 100%;
  border: none;
  outline: none;
`;

const NavLinkHref = styled.a`
  color: white;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  @media screen and( max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
    &:hover {
      color: #4b59f7;
      transition: all 0.3s ease;
    }
  }
`;

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const handleClick = () => setClick(!click);
  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };
  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);
  return (
    <div>
      <IconContext.Provider value={{ color: "white" }}>
        <Nav>
          <NavbarContainer>
            <NavLogo to="/">
              <NavIcon />
              <NavHeading>
                <Typewriter
                  options={{
                    strings: ["Bhupesh Patil | Software Engineer"],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </NavHeading>
            </NavLogo>
            <MobileIcon onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </MobileIcon>
            <NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLink to="about-page" smooth={true} duration={1000}>
                  About me
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLinkHref href={socialMediaLink.resume}>Resume</NavLinkHref>
              </NavItem>
              <NavItem>
                <NavLink to="project-page" smooth={true} duration={1000}>
                  Projects
                </NavLink>
              </NavItem>
              <NavItemBtn>
                {button ? (
                  <NavLink to="footer-page" smooth={true} duration={8000}>
                    <Button primary>Contact me</Button>
                  </NavLink>
                ) : (
                  <NavBtnLink to="footer-page" smooth={true} duration={8000}>
                    <Button fontBig primary>
                      Contact me
                    </Button>
                  </NavBtnLink>
                )}
              </NavItemBtn>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </div>
  );
};

export default Navbar;
